interface BadgeProps {
	text: string;
	className?: string;
}

const Badge = ({ text, className = '' }: BadgeProps) => (
	<span className={`px-3 py-1.5 rounded-full text-xs font-semibold ${className}`}>{text}</span>
);

export { Badge };
